import type { TOC } from '@ember/component/template-only';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
import DiagnosticFields from '../not-donor/diagnostic-fields';

export default <template>
  <div class='field'>
    <@form.Dropdown
      @propertyName='transplantedOrgan'
      @labelName='Type de greffe'
      as |dropdown|
    >
      <dropdown.Item @value='Rein' @key='kidney' />
      <dropdown.Item @value='Rein/Pancréas' @key='kidney-pancreas' />
      <dropdown.Item @value='Rein/Foie' @key='kidney-liver' />
      <dropdown.Item @value='Rein/Poumon' @key='kidney-lung' />
      <dropdown.Item @value='Rein/Poumon/Coeur' @key='kidney-lung-heart' />
      <dropdown.Item @value='Rein/Coeur/Foie' @key='kidney-heart-liver' />
      <dropdown.Item @value='Non renseigné' @key='' />
    </@form.Dropdown>
  </div>

  <div class='two fields' data-test-transplant-date-section>
    <div class='field'>
      <@form.Date
        @labelName='Date de la greffe'
        @propertyName='transplantDate'
      />
    </div>
    <div class='field'>
      <label>
        Rang de la greffe
      </label>
      <div class='four unstackable fields'>
        <@form.BasicRadioGroup @propertyName='transplantRank' as |Group|>
          <Group.FieldRadio @label='1' @value='1' />
          <Group.FieldRadio @label='2' @value='2' />
          <Group.FieldRadio @label='3' @value='3' />
          <Group.FieldRadio @label='4' @value='4' />
        </@form.BasicRadioGroup>
      </div>
    </div>
  </div>

  <div class='field'>
    <@form.AlignedFieldsRadioGroup
      @title='Type de donneur'
      @propertyName='donorType'
      as |Group|
    >
      <Group.FieldRadio @label='Vivant' @value='alive' />
      <Group.FieldRadio @label='Décédé' @value='dead' />
    </@form.AlignedFieldsRadioGroup>
  </div>

  <DiagnosticFields @form={{@form}} />
</template> satisfies TOC<{
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}>;
